<div class="card !p-5">
  <bo-common-table
    [data]="organizers()"
    [columns]="columns"
    [config]="tableConfig"
    [dateRange]="dateRange()"
    [totalRecords]="totalRecords()"
    [rows]="pageSize()"
    [sortField]="sortField()"
    [sortOrder]="sortOrder() === 'asc' ? 1 : -1"
    [mapFieldToSortBy]="mapFieldToSortBy"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
    (dateRangeChange)="onDateRangeChange($event)"
    (sortChangeRequested)="onSortChange($event)"
    (pageChangeRequested)="onPageChange($event)"
  >
    <ng-template #bodyTemplate let-organizer let-rowIndex="rowIndex">
      <tr class="cursor-pointer" (click)="onRowClick(organizer)">
        <td>
          <bo-user-info-cell
            [firstName]="organizer.name"
            lastName=""
            [email]="organizer.email"
            [avatarUrl]="organizer.avatarUrl ?? null"
          />
        </td>
        <td>
          <bo-currency-cell
            [value]="organizer.incomingEarnings"
            currency="EUR"
            locale="fr-FR"
            [showZero]="true"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [subText]="
              organizer.incomingEarnings && organizer.incomingEarnings > 0
                ? organizer.incomingEventsCount + ' ongoing activities'
                : null
            "
          />
        </td>
        <td>
          <bo-currency-cell
            [value]="organizer.availableAmount"
            currency="EUR"
            locale="fr-FR"
            [showZero]="false"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [subText]="organizer.availableAmount && organizer.availableAmount >=10000 ? 'Eligible for withdraw' : null"
            subTextColor="#22AE58"
          />
        </td>
        <td>
          <bo-currency-cell
            [value]="organizer.pendingPayoutAmount"
            currency="EUR"
            locale="fr-FR"
            [showZero]="false"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
          />
        </td>
        <td class="text-right">
          <bo-status-cell [status]="organizer.stripeConnectedStatus" />
        </td>
        <td>
          <bo-action-cell></bo-action-cell>
        </td>
      </tr>
    </ng-template>
  </bo-common-table>
</div>
